/* The hero backdrop: either the illustrated sky (follows the prayer day) or a
   photo the user picked in Settings → Appearance → Background. Photos are
   freely licensed (Wikimedia Commons), self-hosted, credited in About. */
import backgrounds from '@/data/backgrounds.json';
import { useSettings } from '@/lib/store';
import { SkyScene, type Phase } from './Scene';

export interface Background { id: string; label: string; src: string; thumb: string; artist: string; licence: string; page: string; /** CSS object-position focal point */ pos?: string }
export const BACKGROUNDS = backgrounds as Background[];

export function Backdrop({ phase, height, lift = 0, caravan }: { phase: Phase; height: number | string; lift?: number; caravan?: boolean }) {
  const bg = useSettings((s) => s.settings.background);
  const photo = BACKGROUNDS.find((b) => b.id === bg);
  if (!photo) return <SkyScene phase={phase} height={height} lift={lift} caravan={caravan} />;
  return (
    <div className="relative overflow-hidden bg-black" style={{ height }} aria-hidden>
      <img src={photo.src} alt="" className="absolute inset-0 h-full w-full object-cover" style={{ objectPosition: photo.pos ?? '50% 50%' }} decoding="async" />
      {/* keeps text legible on any photo */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/10 to-black/55" />
    </div>
  );
}
